<template>
  <b-dialog  :mshow="successShow">
  <!-- <slide from="bottom" :show="successShow" height="100%"> -->
    <div class="beast-login-warp forget">
      <img v-if="showClose"  class="close" @click="close" src="./assets/close.png">
      <div class="login-head">
        <img src="./assets/wtf.png"></img>
        <p class="title" >密码修改成功</p>
      </div>

      <div class="login-main">
        <div class="forget-tips">
          <p>你的账号密码已修改成功</p>
          <p>点击确定后重新登录</p>
        </div>
      </div>
      <div @click="close" class="login-btn-success">
        确定
      </div>
    </div>
  </b-dialog>

</template>

<script>
import Slide from '@/components/slide'
import BDialog from '@/components/dialog/login-dialog.vue'
export default {
  components:{
    Slide,
    BDialog
  },
  data (){
    return {
    }
  },
  props: {
    showClose: {
      default: true
    },
    successShow: {
      default: false
    }
  },
  methods: {
    close: function (){
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="stylus">
@import './index.styl'

</style>



// WEBPACK FOOTER //
// forget-success.vue?05ecb38e